import * as React from 'react';

var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgBirthday(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.005 14.006v3m14-3v3m-14 0v1a3 3 0 003 3h8a3 3 0 003-3v-1m-14 0h14",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.001 11.755a2.25 2.25 0 002.251 2.251v0c.598 0 1.17-.236 1.592-.66a.953.953 0 011.319 0c.421.424.994.66 1.591.66v0c.597 0 1.17-.236 1.592-.66a.953.953 0 011.319 0c.421.424.994.66 1.591.66v0c.597 0 1.17-.236 1.592-.66a.953.953 0 011.318 0c.422.424.995.66 1.592.66v0a2.251 2.251 0 002.251-2.25v0a2.751 2.751 0 00-2.751-2.752H5.753A2.751 2.751 0 003 11.755z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.003 9.005V7.004M17.007 9.005V7.004M12.005 9.005V7.004M7.003 4.002v-1M12.005 4.002v-1M17.007 4.002v-1",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export { SvgBirthday as ReactComponent };
